import { Platform, StyleSheet } from 'react-native';
import { DEVICE_SIZES, useDeviceSize } from 'rn-responsive-styles';

import { isDeviceMinimumSize, spacing } from '@pletly/ui';

import { Env } from '@env';
import { FileType, PostType } from '%__generated__/types';
import { MediaSlider } from '%components/MediaSlider';
import { GetPostQuery } from '%components/PostComments/__generated__/post.generated';
import { FileList } from '%components/Files';
import { NewBookContent } from './components/NewBookContent';
import { TextContent } from './components/TextContent';

type Props = Pick<GetPostQuery['post'], 'content' | 'mediaFiles' | 'type'>;

const DESKTOP_SLIDER_HEIGHT = 700;
const MOBILE_SLIDER_HEIGHT = 250;

export const PostContent = ({ mediaFiles: files, content, type }: Props) => {
	const deviceSize = useDeviceSize();
	const isNotMobile = isDeviceMinimumSize(deviceSize, DEVICE_SIZES.MEDIUM_DEVICE);
	const sliderHeight =
		Platform.OS !== 'web' ? undefined : isNotMobile ? DESKTOP_SLIDER_HEIGHT : MOBILE_SLIDER_HEIGHT;

	const Text = <TextContent text={content} />;
	const mediaFiles = files.filter((file) => file.type !== FileType.Other);
	const otherFiles = files.filter((file) => file.type === FileType.Other);

	return (
		<>
			{Platform.OS === 'web' && Text}
			{mediaFiles?.length > 0 && (
				<MediaSlider style={styles.media} images={mediaFiles} height={sliderHeight} />
			)}
			{otherFiles.length > 0 && <FileList files={otherFiles} />}
			{type === PostType.Book && Env.ENABLE_BOOK_NOTIFICATIONS && <NewBookContent />}
			{Platform.OS !== 'web' && Text}
		</>
	);
};

export const styles = StyleSheet.create({
	media: {
		marginBottom: spacing(),
	},
});
